import React from 'react';
import { Typography, Card, CardContent, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { LoadingButton } from '@mui/lab';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

const statuses = {
    "canceled": "Canceled",
    "awaiting_user_input": "Awaiting Input",
    "success": "Success",
    "expired": "Expired",
    "fail": "Failed"
}

const projectIds = {
    "project_ailLFGYlXLhgXRl5FD9nMiQwOLIoihWZfEyKMfgA0q": "POC Verification",
    "project_jAqFHqFvQH3ECRhGydymBMEvIL55tMn4BWVRxeengJ": "IAL2 Identity Verification",
    "project_GMttCYLUuHHAnJG71IkGvvgSEHbHyzI3gkVCL3l3Ji": "Advanced Document Verification",
    "project_UQmUrCXb4MbbewaG2zU5cbGiVHHjW4EMtjpLTPe19Q": "Document Verificaiton"
}

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));
  
const Clearme = ({projects, isAdmin}) => {
    const [verificationSessions, setVerificationSessions] = React.useState(null);
    const [loading, setLoading] = React.useState(false);

    const fetchData = async () => {
        setLoading(true);
        try {
            fetch('/api/clearme/sessions/list').then((response) => {
                setLoading(false);
                if (!response.ok) throw new Error(response.statusText);
                return response.json();
            })
            .then((data) => {
                // Handle the response data
                setVerificationSessions(data);
            })
            
        } catch (error) {
            console.error(error);
        }
    };

    const createVerificationSession = async (project_id) => {
        try {
            fetch('/api/clearme/sessions', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ project_id })
            }).then((response) => {
                if (!response.ok) throw new Error(response.statusText);
                return response.json();
            })
            .then((data) => {
                const verificationURL = "https://verified.clearme.com/verify?token=" + data.token;
                window.location.href = verificationURL;
            })
            
        } catch (error) {
            console.error(error);
        }
    };

    const projectMapping = (project_id) => {
        return projectIds[project_id];
    };

    const statusMapping = (status) => {
        return statuses[status];
    }

    const convertTimestampToEpoch = (timestamp) => {
        const myDate = new Date(timestamp * 1000);
        return new Intl.DateTimeFormat('en-US', {
            dateStyle: 'short',
            timeStyle: 'short'
        }).format(myDate)
    }

    return (
        <div>
            <Card>
                <CardContent>
                    <Typography variant="h5" component="h2">
                        Clear Verification
                    </Typography>
                    {isAdmin && (
                        <Stack direction="row" spacing={2}>
                            <LoadingButton
                                size="small"
                                loading={loading} 
                                onClick={fetchData}
                                loadingPosition="center"
                                variant="contained"
                            >
                                All Verifications
                            </LoadingButton>
                        </Stack>
                    )}
                    
                    <Stack direction="row" spacing={2} style={{ marginTop: '10px' }}>
                        {Object.keys(projects).map((id, index) => (
                            <LoadingButton
                                key={index}
                                size="small"
                                loading={loading} 
                                onClick={createVerificationSession.bind(this, id)}
                                loadingPosition="center"
                                variant="contained"
                            >
                                {projects[id]}
                            </LoadingButton>
                        ))}
                    </Stack>
                </CardContent>
            </Card>
            {verificationSessions ? (
                <div>
                    <h2>Verifications</h2>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>ID</TableCell>
                                    <TableCell>Verification ID</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Last Updated</TableCell>
                                    <TableCell>Phone</TableCell>
                                    <TableCell>Email</TableCell>
                                    {/* Add more table headers as needed */}
                                </TableRow>
                            </TableHead>
                            <TableBody stripedRows>
                                {verificationSessions.verifications.map((verification, index) => (
                                    <StyledTableRow key={index}>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>{projectMapping(verification.project_id)}</TableCell>
                                        <TableCell>{statusMapping(verification.status)}</TableCell>
                                        <TableCell>{convertTimestampToEpoch(verification.updated_at)}</TableCell>
                                        <TableCell>{verification.traits?.phone || ''}</TableCell>
                                        <TableCell>{verification.traits?.email || ''}</TableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            ) : (
                <div></div>
            )}
        </div>
    );
};

export default Clearme;
